module.exports = __webpack_public_path__ + "img/bolt-lightning.d5ce482a.svg";